import React from 'react';

const CharacterCounter = ({ current, max }) => {
  const percentage = (current / max) * 100;
  const isNearLimit = percentage > 80;
  const isAtLimit = current >= max;

  return (
    <div className="flex items-center justify-between gap-4 px-1">
      <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${
            isAtLimit
              ? 'bg-error'
              : isNearLimit
              ? 'bg-warning' :'bg-primary'
          }`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <span
        className={`text-xs md:text-sm font-medium transition-colors ${
          isAtLimit
            ? 'text-error'
            : isNearLimit
            ? 'text-warning' :'text-muted-foreground'
        }`}
      >
        {current} / {max}
      </span>
    </div>
  );
};

export default CharacterCounter;